<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.asset-group.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.asset-group.line-1") }}
            </p>

            <p>{{ $t("help.platform.asset-group.line-2") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.asset-group.organization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.asset-group.organization.line-1") }}
              </p>

              <img src="@/assets/images/help/organization-asset-group.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.asset-group.organization.line-2") }}
              </p>
              <img src="@/assets/images/help/asset-group-library-item.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.asset-group.organization.line-3") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.asset-group.organization.line-4") }}
              </p>
              <img src="@/assets/images/help/organization-asset-group2.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.asset-group.organization.line-5") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.asset-group.organization.line-6") }}
              </p>

              <ul class="mt-3 mb-3">
                <li>
                  <p>
                    {{ $t("help.platform.asset-group.organization.line-7") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.asset-group.organization.line-8") }}
                  </p>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.asset-group.list.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.asset-group.list.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/asset-group-list.png" class="image" />

              <p class="mt-3">{{ $t("help.platform.asset-group.list.line-2") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.asset-group.criticality.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.asset-group.criticality.line-1") }}
              </p>
              <img src="@/assets/images/help/asset-group-criticality.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-2") }}</p>
              <img src="@/assets/images/help/asset-group-criticality-edit.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-4") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-5") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-6") }}</p>
              <img src="@/assets/images/help/asset-group-survey-result.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.asset-group.criticality.line-7") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
